module.exports = __webpack_public_path__ + "assets/img/logo_big.289e69cf.png";